import { render, staticRenderFns } from "./listIconArr.vue?vue&type=template&id=46c70278&scoped=true&"
import script from "./listIconArr.vue?vue&type=script&lang=js&"
export * from "./listIconArr.vue?vue&type=script&lang=js&"
import style0 from "./listIconArr.vue?vue&type=style&index=0&id=46c70278&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c70278",
  null
  
)

export default component.exports